import React, { FC } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Text } from 'wix-ui-tpa/cssVars';
import {
  getDateLocale,
  getDateTime,
  getRelativeDateTime,
  isMoreThanWeekBefore,
} from '../../utils/date';
import { classes } from './NotificationItem.st.css';

interface Props {
  time: Date;
  dataHook: string;
}

export const TimeAgo: FC<Props> = ({ time, dataHook }) => {
  const {
    i18n: { language },
  } = useTranslation();
  const locale = getDateLocale(language);

  return (
    <Text className={classes.content} data-hook={dataHook}>
      {isMoreThanWeekBefore(time)
        ? getDateTime(locale, time)
        : getRelativeDateTime(locale, time)}
    </Text>
  );
};
